import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { setSortOption } from '../beneficiary-list-filters/slice'
import { State } from './types'

const initialState: State = {
  beneficiaryListSortOption: {
    field: 'fullName',
    direction: 'ASC',
  },
  beneficiaryListColumnIds: ['profile'],
} satisfies State

const slice = createSlice({
  name: 'caseWorkerPreferences',
  initialState,
  reducers: {
    setCaseWorkerPreferences: (state, action: PayloadAction<State>) => {
      state.beneficiaryListSortOption = action.payload.beneficiaryListSortOption
      state.beneficiaryListColumnIds = action.payload.beneficiaryListColumnIds
    },
    setBeneficiaryListSortOption: (
      state,
      action: PayloadAction<State['beneficiaryListSortOption']>,
    ) => {
      state.beneficiaryListSortOption = action.payload
    },
    setBeneficiaryListColumnVisibility: (
      state,
      action: PayloadAction<{ columnId: string; visible: boolean }>,
    ) => {
      const { columnId, visible } = action.payload

      if (!visible) {
        state.beneficiaryListColumnIds = state.beneficiaryListColumnIds.filter(
          (id) => id !== columnId,
        )
      } else if (!state.beneficiaryListColumnIds.includes(columnId)) {
        state.beneficiaryListColumnIds.push(columnId)
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setSortOption, (state, action) => {
      state.beneficiaryListSortOption = action.payload
    })
  },
})

export type { State as CaseWorkerPreferencesState }
export const caseWorkerPreferencesInitialState = initialState
export default slice.reducer

export const { setCaseWorkerPreferences, setBeneficiaryListColumnVisibility } = slice.actions
